<div class="clearfix">
  <div class="col-12 md:col-12"><h3>{{'Mg_Assoc' | translate}}</h3></div>
  <div class="col-12 md:col-12">
    <p-tabView  [controlClose]="true" (onChange)="handleChange($event)" (onClose)="closeTab($event)" [activeIndex]="index">
      <p-tabPanel [header]="'List' | translate"  [selected]="0 == index" [headerStyle]="{'font-weight':'bold'}">
        <div class="table-tools">
          <button [disabled]="tagList.length === 0" (click)="changeView($event)" class="p-button p-component p-button-text-only btn-square margin"
          >{{libSens}}</button>
          <button [disabled]="tagList.length === 0" (click)="add($event)" class="p-button p-component p-button-text-only btn-square">{{'Add_Assoc' | translate}}</button>
        </div>
        <br class="col-12 md:col-12">
        <p-table #dt [selectionMode]="'single'" [columns]="listColumns" [value]="requests" [rows]="100"
          [paginator]="true" responsiveLayout="stack" [breakpoint]="'960px'" (onRowSelect)="showDetails($event)" (onFilter)="setFilteredList($event)" [sortField]="'name'"
          dataKey="id"
          id="requests"
          styleClass="rowexpand-table">
          <ng-template pTemplate="caption">
            <span class="header-grid-wrapper">
              @if (sens==='r') {
                <span class="align-right">{{'Tot' | translate}} {{requests.length}} {{'Mg_MenuBsk' | translate}}</span>
              }
              @if (sens==='b') {
                <span class="align-right">{{'Tot' | translate}} {{requests.length}} {{'Mg_BskMenu' | translate}}</span>
              }
            </span>
          </ng-template>
          <ng-template let-columns pTemplate="header">
            <tr>
              <th style="width: 3rem"></th>
              <th [pSortableColumn]="columns[0].field" class="width-auto">
                <p-sortIcon [field]="columns[0].field"></p-sortIcon>{{columns[0].header}}
                <input (click)="$event.stopPropagation()" pInputText type="text" (input)="dt.filter($event.target.value, columns[0].field, 'contains')"
                  style="color: darkgrey;">
                </th>
              </tr>
            </ng-template>
            <ng-template let-rowData let-columns="columns" pTemplate="body" let-expanded="expanded">
              <tr [pSelectableRow]="rowData">
                <td>
                  <button pButton type="button" [pRowToggler]="rowData" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td class="width-auto">
                  {{rowData[columns[0].field]}}
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-requests>
              <tr>
                <td colspan="7">
                  <div class="p-3">
                    <p-table [value]="requests.baskets" dataKey="name">
                      <ng-template pTemplate="body" let-basket>
                        <tr>
                          <td>
                            {{basket.label}}
                          </td>
                          @if (sens==='b') {
                            <td><p-button type="button" icon="pi pi-pencil" (click)="showDetailsExpand(basket)"></p-button></td>
                          }
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="6">{{'Bsk_Empty_2' | translate}}</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7">{{'Empty' | translate}}</td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabPanel>
        @for (item of itemsSelected; track item; let i = $index) {
          <p-tabPanel header="{{item._label}}" [selected]="i == index -1"  [closable]="true">
            @if (item.id===-1) {
              <app-add-screenbsk
                [tagList]="tagList"
                [basketList]="basketList"
                (onCancel)="cancelAdd($event)"
                (onValidate)="addTab($event)">
              </app-add-screenbsk>
            }
            @if (item.id!==-1) {
              <app-edit-screenbsk
                [tagList]="tagList"
                [basketList]="basketList"
                [item]="item"
                (onCancel)="closeTab($event)"
                (onValidate)="validateTab($event)"
                (onDeleteItem)="confirmDelete($event)">
              </app-edit-screenbsk>
            }
          </p-tabPanel>
        }
      </p-tabView>
    </div>
  </div>

  <app-item-confirm
    [key]="'delete'"
    [severity]="'alert'"
    (onAccept)="delete($event)"
  ></app-item-confirm>
